/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const NestedNotInResourceId: core.serialization.ObjectSchema<
    serializers.NestedNotInResourceId.Raw,
    Truvity.NestedNotInResourceId
> = core.serialization.object({
    values: core.serialization.list(core.serialization.string()),
});

export declare namespace NestedNotInResourceId {
    export interface Raw {
        values: string[];
    }
}
